// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'person-solid';

export const Component = () => (
  <path d='M10.3 6.028c-.527-.526-.814-1.245-.814-2.06 0-.813.287-1.532.862-2.106.575-.575 1.245-.862 2.059-.862.814 0 1.484.288 2.107.91.575.575.862 1.245.862 2.06 0 .814-.288 1.484-.862 2.059a2.89 2.89 0 0 1-2.107.862 2.893 2.893 0 0 1-2.107-.862Zm-.862 2.874c.623-.67 1.628-1.006 2.97-1.006 1.341 0 2.347.335 2.97 1.006.957.957 1.436 2.155 1.436 3.543v2.539c0 .382-.144.766-.431 1.101a1.408 1.408 0 0 1-1.054.431h-.479v5.556c0 .431-.144.766-.431 1.054-.335.335-.67.479-1.054.479h-1.916c-.383 0-.719-.144-1.054-.48a1.408 1.408 0 0 1-.43-1.053v-5.556h-.48a1.41 1.41 0 0 1-1.054-.43A1.687 1.687 0 0 1 8 14.983v-2.539c0-1.389.479-2.586 1.437-3.543h.001Z' />
);

export const viewBox = '0 0 25 25';
